module.exports = __webpack_public_path__ + "static/media/cancel_2.0d023025.png";